import React from 'react';
import styles from './styles.scss';
import {CaptureScheduleModalState, Status} from '../../types/capture-schedule-modal';
import { CaptureScheduleModalSensor } from '.';

import {LoadingBar} from './utils';
import ErrorState from '../ErrorState';

import {AppBar, AppBarContext, AppBarSection, Button, ButtonGroup,} from '@densityco/ui';

import captureScheduleModalSubmit from '../../rx-actions/capture-schedule-modal-submit';

import {DispatchType} from '../../types/rx-actions';

const {Fragment, useEffect} = React;
import { Hosts } from '../../utils/host';


type ProcessingPageProps = {
  state: CaptureScheduleModalState,
  sensors: Array<CaptureScheduleModalSensor>,
  dispatch: DispatchType,
  onDismiss: () => void,
  jwtToken: string,
};
const ProcessingPage: React.FunctionComponent<ProcessingPageProps> = (props) => {
  const {state, dispatch, jwtToken, sensors, onDismiss} = props;

  function makeRequests() {
    captureScheduleModalSubmit(dispatch, state, sensors, jwtToken);
  }

  useEffect(makeRequests, []);

  // FIXME: pick the first organization here because we can only filter by a single organization in
  // django admin. We should revisit this, it's potentially confusing behavior if you have selected
  // sensors in multiple organizations.
  const selectedOrganization = sensors[0].organization;
  const coreCucumberUrl = `${Hosts.CoreCucumberHost}/api/captureschedule/${selectedOrganization ? (
    `?organization__name=${encodeURIComponent(selectedOrganization.name)}`
  ) : ''}`;

  return (
    <Fragment>
      <div className={styles.processingPage}>
        {state.finalRequestStatus === Status.LOADING ? (
          <LoadingBar width={500}/>
        ) : null}
        {state.finalRequestStatus === Status.COMPLETE ? (
          <p>Creating capture schedules successful!</p>
        ) : null}
        {state.finalRequestStatus === Status.ERROR ? (
          <div>
            <ErrorState error={state.finalRequestError} />
          </div>
        ) : null}
      </div>
      <AppBarContext.Provider value="BOTTOM_ACTIONS">
        <AppBar>
          <AppBarSection />
          <AppBarSection>
            <ButtonGroup>
              <Button onClick={() => onDismiss()}>Return to Sensei</Button>
              {state.finalRequestStatus === Status.ERROR ? (
                <Button variant="filled" onClick={() => makeRequests()}>Retry</Button>
              ) : null}
              {state.finalRequestStatus === Status.COMPLETE ? (
                <Button
                  href={coreCucumberUrl}
                  variant="filled"
                >View Capture Schedules</Button>
              ) : null}
            </ButtonGroup>
          </AppBarSection>
        </AppBar>
      </AppBarContext.Provider>
    </Fragment>
  );
};
export default ProcessingPage;
